module.exports = __webpack_public_path__ + "media/assets/icons/triangle-down-01bcb9f8b5eb49db60e396d950ea56eb.svg";